import { render, staticRenderFns } from "./ShowClientAccountManager.vue?vue&type=template&id=6b1b9bb4"
import script from "./ShowClientAccountManager.vue?vue&type=script&lang=js"
export * from "./ShowClientAccountManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports